import React, { useState } from "react";
import { Modifier, EditorState } from "draft-js";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { useMessagesPlaceholders } from "stores";
import Select from "components/select/Select";

const SelectStyled = styled(Select)({
  width: "150px",
  marginRight: "0.5rem",
  "&:hover": {
    backgroundColor: "#e8e8e8",
    borderRadius: "3px",
    transition: "background-color 0.2s",
  },
  "& .label, .placeholder": {
    marginBottom: "0",
    marginLeft: "0",
    color: "#6f6f6f",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    borderRadius: "0",
  },
});

const InsertPlaceholderDropdown = ({ editorState, onChange, className }) => {
  const { placeholders } = useMessagesPlaceholders();

  // State to manage the selected value
  const [selectedValue, setSelectedValue] = useState("");

  const { t } = useTranslation();

  const handleChange = (event) => {
    const placeholder = event.target.value;
    if (placeholder === "") return; // Do nothing if the default option is selected

    insertPlaceholder(placeholder);
    setSelectedValue(""); // Reset the select to default after insertion
  };

  const insertPlaceholder = (placeholder) => {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();

    // Find the label of the placeholder
    const placeholderLabel = placeholders.find(
      (placeholderObj) => placeholderObj.value === placeholder
    ).label;

    // Create the placeholder text with curly braces
    const textWithPlaceholder = `{{${placeholderLabel}}}`;

    // Insert the placeholder text at the current cursor position
    const newContentState = Modifier.insertText(
      contentState,
      selectionState,
      textWithPlaceholder
    );

    // Push the new content state to the editor
    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      "insert-characters"
    );

    onChange(newEditorState);
  };

  if (!placeholders) return null;

  return (
    <div className={className}>
      <SelectStyled
        isFullWidth={false}
        placeholder={t("RichTextEditor.Label")}
        value={selectedValue}
        onChange={handleChange}
        options={placeholders}
      />
    </div>
  );
};

export default InsertPlaceholderDropdown;
